const light = ({ targetColor }) => targetColor;

export default light;
